import React, { Component } from 'react';
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import { toggleInstOpened } from "../../actions/actionFunctions";

import InstList from "./instList";
import Analytics from './../../analytics';

class InstView extends Component {

  constructor(props) {
    super(props);
    this.state = {
      unmount: false
    };
  }

  componentDidMount() {

  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    Analytics.sendClickEvent('installations-close');
    if (!nextProps.instOpened && this.props.instOpened) {
      this.setState({
        unmount: true
      }, () => {
        setTimeout(() => {
          this.setState({
            unmount: false
          })
        }, 500)
      })
    }

  }

  closeInstallationView = () => {
    this.props.toggleInstOpened(false);
  };

  render() {

    return (
      <div className={"inst" + (this.props.instOpened ? " inst--opened" : "") + (this.state.unmount ? " inst--unmount" : "")}>
        <div className="inst-header">
          <h2 className="inst-header__title"><FormattedMessage id="installations.title"/></h2>
          <p className="inst-header__description"><FormattedMessage id="installations.description"/></p>
        </div>
        <button className="ui-close ui-close--white inst-close" onClick={this.closeInstallationView}/>
        <div className="inst-content">
          <InstList/>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    instOpened: store.instState.instOpened,
    instState: store.instState.instState
  };
};

export default connect(mapStateToProps, {
  toggleInstOpened
})(InstView);
